import safeRegexLib from 'safe-regex';

/**
 * проверка Regexp паттерна на безопанось
 */

export const isSafeRegex = (pattern: string) => safeRegexLib(pattern);
